export default "__VITE_ASSET__Dsk9lNxS__"